import React from 'react'
import SearchTopBox from '../../components/searchtopbox/SearchTopBox'

const Search = () => {
  return (
    <div className='dashboard-content-box'>
        <SearchTopBox />
    </div>
  )
}

export default Search
